import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    applyClubBoth,
} from './../../../actions/FilterActions';
import common from '../../../common';
import config from '../../../config'

class ClubsFilterMobile extends Component {
    onClubFilterApply = (club) => {
        this.props.applyClubBoth(club);

    };

    render() {
        return <div className="si-filter-types si-clubs-filter">
            <span className="si-title">{ this.props.trans.filterByTeam }</span>
            <div className="sorting-wrap si-flexBox">
                { this.props.teams.map((el) => {
                    const teamImg = config.UEFAImgBase + `teams/logos/140x140/${el['TID']}.png`;
                    const isSelected = this.props.teamIds.indexOf(el['TID']) > -1;
                    const className = common.makeClasses({
                        'si-sort-option': true,
                        'si-selected': isSelected,
                    });
                    return <div className="si-sort-box" onClick={ () => this.onClubFilterApply(el) } key={ el['TID'] }>
                        <div className={ className } >
                            <span className="si-sort-img" style={ { backgroundImage: "url(" + teamImg + ")" } }></span>
                            <span className="si-sort-tick"></span>
                        </div>
                        <div className="si-sort-name">{ el['WebName'] }</div>
                    </div>


                }) }
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teams: state.formationData.teams,
        teamIds: state.formationData.playerFilters.teamIds,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applyClubBoth: (club) => dispatch(applyClubBoth(club)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ClubsFilterMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ClubsFilterMobile.js